import {
  IGetNewbuildingJsonQueryResponse200,
  IGetNewbuildingJsonQueryResponse400,
} from '../../repositories/newbuilding-search/v2/get-newbuilding-json-query';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

export function assertBadStatusCodeError(
  response: IGetNewbuildingJsonQueryResponse200 | IGetNewbuildingJsonQueryResponse400,
) {
  if (response.statusCode === 200) {
    return;
  }

  throw new HttpBadStatusCodeError({
    statusCode: 400,
    domain: 'src/shared/api/jsonQuery/assertNotFoundError.ts',
    message: 'JsonQuery empty response',
  });
}
